import React, {PropTypes} from 'react';


function JobRequestIcon(props) {
  const {
    className,
    showPlus,
    ...otherProps
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" viewBox="0 0 20 26" className={`company-icon ${className}`} {...otherProps}>
        <g fill="none" fillRule="evenodd">
            <g fill="#FAFAFA" fillRule="nonzero">
                <path d="M12.979 1.027v-1H5v1H.016v18.952h17.952V1.027h-4.99zm-5.984.994h3.989v1h-3.99v-1zm8.978 15.958H2.011V3.02H5v1.995h7.979V3.021h2.994V17.98z"/>
                <path d="M4.005 7.011H6v1.995H4.005zM7.995 7.011h5.984v1.995H7.995zM4.005 11H6v1.995H4.005zM7.995 11h5.984v1.995H7.995zM4.005 14.989H6v1.995H4.005zM7.995 14.989h5.984v1.995H7.995z"/>
            </g>
            {showPlus
              &&
              <g transform="translate(8 12)">
                  <circle cx="7" cy="7" r="7" fill="#151921"/>
                  <g stroke="#FAFAFA" strokeWidth="2">
                      <path d="M3 7h8M7 3v8"/>
                  </g>
              </g>
            }
        </g>
    </svg>
  );
}


JobRequestIcon.propTypes = {
  className: PropTypes.string
};

export default JobRequestIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/JobRequestIcon/index.js